"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var IconFont_exports = {};
__export(IconFont_exports, {
  IconFont: () => IconFont
});
module.exports = __toCommonJS(IconFont_exports);
var import_react = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
var import_IconMappings = require("./IconMappings");
var iconClasses = Object.keys(import_IconMappings.IconMappings).map(function(iconName) {
  return (0, import_styled_components.css)(["&.im-", "{&:before{content:'\\", "';}}"], iconName, import_IconMappings.IconMappings[iconName]);
});
var StyledIcon = import_styled_components.default.i.withConfig({
  displayName: "IconFont__StyledIcon",
  componentId: "sc-10ldupi-0"
})(["font-family:'IcoMinds-Font' !important;speak:none;font-style:normal;font-weight:normal;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-size:", ";", ""], function(_ref) {
  var size = _ref.size;
  return size ? "".concat(size, "px") : "inherit";
}, iconClasses);
var IconFont = function IconFont2(_ref2) {
  var name = _ref2.name, size = _ref2.size, _ref2$className = _ref2.className, className = _ref2$className === void 0 ? "" : _ref2$className, role = _ref2.role, ariaLabel = _ref2.ariaLabel, _ref2$ariaHidden = _ref2.ariaHidden, ariaHidden = _ref2$ariaHidden === void 0 ? true : _ref2$ariaHidden;
  var value = !name ? "error" : "";
  return /* @__PURE__ */ import_react.default.createElement(import_react.default.Fragment, null, /* @__PURE__ */ import_react.default.createElement(StyledIcon, {
    size,
    className: "im im-".concat(name, " ").concat(className),
    role,
    "aria-label": ariaLabel,
    "aria-hidden": ariaHidden
  }, value));
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  IconFont
});
//# sourceMappingURL=index.js.map